<template>
  <el-card class="main-card pending-return-detail">
    <template #header>
      <div class="pending-detail-header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/stock/bills/pendingReturn' }">待回货管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{ id ? '详情' : '新增' }}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button type="primary" plain icon="QuestionFilled" @click="showHelpDialog = true">操作帮助</el-button>
      </div>
    </template>

    <el-alert v-if="isReturnBill" type="info" :closable="false" show-icon class="mode-alert">
      <template #title>
        当前为待回货单，原出库单号：{{ sourceBillCode || '-' }}
      </template>
    </el-alert>

    <el-form :model="bill" label-width="100px" class="bill-form">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="流程类型">
            <el-select v-model="template" :disabled="!!id" @change="onTemplateChange">
              <el-option label="维修" value="repair"></el-option>
              <el-option label="融金" value="gold"></el-option>
              <el-option label="送料加工" value="tolling"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="结案方式">
            <el-select v-model="completionMode" :disabled="template == 'repair' || template == 'tolling' || !!id" @change="onCompletionChange">
              <el-option label="回货入库" value="return"></el-option>
              <el-option label="回款结案" value="cash"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="单据编号">
            <el-input v-model="bill.billCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item :label="isReturnBill ? '待回货状态' : '出库单状态'">
            <el-tag :type="statusType(bill.status)">{{ statusText(bill.status) }}</el-tag>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="单据时间">
            <el-date-picker v-model="bill.billDate" type="datetime" format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" style="width:100%"
              :disabled="isLocked"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="所属公司">
            <el-tree-select v-model="bill.companyId" :data="companys" check-strictly :render-after-expand="false"
              :disabled="!!id || sourceDetails.length > 0" @change="onCompanyChange" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="渠道">
            <el-input v-model="bill.channelCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="申请人">
            <el-input v-model="bill.operatorName" :disabled="isLocked"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="bill.reason" :disabled="isLocked"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-tabs v-model="activeTab" class="pending-tabs">
      <el-tab-pane v-if="template == 'tolling'" label="加工信息" name="basic">
        <template v-if="activeTab === 'basic'">
      <el-form :model="tolling" label-width="110px" class="bill-form">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="加工供应商">
              <el-select v-model="tolling.supplierID" filterable :disabled="!!id" style="width:100%" @change="onTollingSupplierChange">
                <el-option v-for="item in suppliers" :key="item.id" :label="item.supplierName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="加工单号"><el-input v-model="tolling.processorOrderNo" :disabled="!!id"></el-input></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="联系人"><el-input v-model="tolling.contactName" :disabled="!!id"></el-input></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="联系电话"><el-input v-model="tolling.contactPhone" :disabled="!!id"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="6">
            <el-form-item label="预计回货日">
              <el-date-picker v-model="tolling.expectedReturnDate" type="date" value-format="YYYY-MM-DD" :disabled="!!id" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col v-if="isReturnBill" :xs="24" :sm="12" :md="6"><el-form-item label="入库状态"><el-tag>{{ inboundState || '未转入库' }}</el-tag></el-form-item></el-col>
        </el-row>
      </el-form>

      <el-divider content-position="left">计划回货成品</el-divider>
      <div class="table-toolbar" v-if="!id">
        <el-button type="primary" plain icon="Plus" @click="addTollingPlan">新增计划成品</el-button>
      </div>
      <el-table max-height="520" :data="tollingPlanRows" stripe border size="small" style="width:100%;">
        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
        <el-table-column label="系统款号" width="200">
          <template #default="scope">
            <el-autocomplete
              v-if="!id"
              v-model="scope.row._skuKeyword"
              :fetch-suggestions="skuFetchSuggestions"
              placeholder="输入系统款号、名称或品牌款号"
              clearable
              style="width:100%"
              @select="selectTollingPlanSku(scope.row, $event)"
              @change="resolveTollingPlanInput(scope.row)"
            ></el-autocomplete>
            <span v-else>{{ scope.row.detailCode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="detailName" label="成品名称" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="unitName" label="单位" width="90"></el-table-column>
        <el-table-column label="默认入库仓库" width="160">
          <template #default="scope">
            <el-select v-if="!id" v-model="scope.row.storeCode" style="width:100%">
              <el-option v-for="item in dict.stores" :key="item.value" :label="item.label || item.name" :value="item.value"></el-option>
            </el-select>
            <span v-else>{{ scope.row.storeCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="计划数量" width="120">
          <template #default="scope"><el-input v-if="!id" v-model="scope.row.plannedQuantity" @change="normalizeNumberField(scope.row, 'plannedQuantity')"></el-input><span v-else>{{ scope.row.plannedQuantity }}</span></template>
        </el-table-column>
        <el-table-column v-if="id" prop="actualQuantity" label="已回数量" width="100"></el-table-column>
        <el-table-column v-if="id" prop="pendingQuantity" label="待回数量" width="100"></el-table-column>
        <el-table-column v-if="id" prop="varianceQuantity" label="差异" width="90"></el-table-column>
        <el-table-column v-if="!id" label="操作" width="80"><template #default="scope"><el-button type="danger" link @click="removeTollingPlan(scope.$index)">删除</el-button></template></el-table-column>
      </el-table>

        </template>
      </el-tab-pane>
      <el-tab-pane label="出库货品" name="outbound">
        <template v-if="activeTab === 'outbound'">
    <template v-if="isReturnBill && sourceBill">
      <el-divider content-position="left">出库单信息</el-divider>
      <el-descriptions border :column="4" size="small">
        <el-descriptions-item label="出库单号">{{ sourceBill.billCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="出库状态">
          <el-tag :type="statusType(sourceBill.status)">{{ statusText(sourceBill.status) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="库房">{{ sourceBill.storeCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="渠道">{{ sourceBill.channelCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="出库单">
          <el-button type="primary" plain size="small" icon="Tickets" @click="openSourceOutBill">查看出库单</el-button>
        </el-descriptions-item>
      </el-descriptions>
    </template>

    <el-divider content-position="left">出库明细</el-divider>
    <div class="table-toolbar" v-if="!id">
      <el-button type="primary" plain icon="Plus" @click="openAddDialog">添加出库货品</el-button>
      <el-button type="danger" plain icon="Delete" :disabled="sourceDetails.length === 0" @click="clearSourceDetails">清空明细</el-button>
    </div>
    <el-table max-height="520" :data="sourceDetails" stripe border size="small" style="width:100%;">
      <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
      <el-table-column prop="sourceBillCode" label="出库原单号" width="140" show-overflow-tooltip></el-table-column>
      <el-table-column prop="serialCode" label="批次号" width="130" show-overflow-tooltip></el-table-column>
      <el-table-column prop="detailCode" label="系统款号" width="130" show-overflow-tooltip></el-table-column>
      <el-table-column prop="brandModelCode" label="品牌款号" width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="detailName" label="名称" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="storeCode" label="库房" width="90"></el-table-column>
      <el-table-column prop="channel" label="渠道" width="90"></el-table-column>
      <el-table-column prop="stockNumber" label="出库数量" width="110">
        <template #default="scope">
          <el-input v-if="!id" v-model="scope.row.stockNumber" @change="normalizeNumberField(scope.row, 'stockNumber')"></el-input>
          <span v-else>{{ scope.row.stockNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="stockRemain" label="可用数" width="90"></el-table-column>
      <el-table-column prop="weight" label="克重" width="90"></el-table-column>
      <el-table-column prop="goldWeight" label="金重" width="90"></el-table-column>
      <el-table-column prop="productPrice" label="成本" width="100"></el-table-column>
      <el-table-column v-if="id" label="状态" width="90" align="center">
        <template #default="scope">
          <el-tag :type="sourceDetailStatusType(scope.row)">{{ sourceDetailStatusText(scope.row) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="!id || canCancelApplication" label="操作" width="105" align="center">
        <template #default="scope">
          <el-button v-if="!id" type="primary" link size="small" @click="removeSource(scope.row)">删除</el-button>
          <el-tooltip v-else-if="String(scope.row.status || '0') == '0'" placement="top"
            :content="activeSourceDetailCount <= 1 ? '至少保留一条有效明细；如需全部取消，请使用取消申请' : '取消该行出库'">
            <span>
              <el-button type="danger" link size="small" :disabled="!canCancelSourceDetail(scope.row)"
                @click="cancelSourceDetail(scope.row)">取消出库</el-button>
            </span>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>

        </template>
      </el-tab-pane>
      <el-tab-pane v-if="isReturnBill" :label="requiresReturn ? '回货处理' : '回款处理'" name="return">
        <template v-if="activeTab === 'return'">
    <template v-if="isReturnBill">
      <template v-if="requiresReturn">
        <el-divider content-position="left">{{ template == 'repair' ? '维修回货入库' : (template == 'tolling' ? '送料加工分批回货' : '融金回货入库') }}</el-divider>
        <template v-if="isRepairBatchMode">
          <el-alert type="info" :closable="false" class="repair-progress-alert">
            <template #title>
              预计 {{ repairProgress.plannedQuantity || 0 }} 件，已完成 {{ repairProgress.completedQuantity || 0 }} 件，
              审核中 {{ repairProgress.processingQuantity || 0 }} 件，待回 {{ repairProgress.pendingQuantity || 0 }} 件
            </template>
          </el-alert>
          <el-table max-height="520" :data="repairPlans" border size="small" class="saved-batch-table return-table">
            <el-table-column prop="plan.detailCode" label="预计系统款号" width="150"></el-table-column>
            <el-table-column prop="plan.detailName" label="名称" min-width="160"></el-table-column>
            <el-table-column prop="plan.serialCode" label="原出库批次" width="150"></el-table-column>
            <el-table-column prop="plan.stockNumber" label="预计" width="80"></el-table-column>
            <el-table-column prop="completedQuantity" label="已完成" width="85"></el-table-column>
            <el-table-column prop="processingQuantity" label="审核中" width="85"></el-table-column>
            <el-table-column prop="pendingQuantity" label="待回" width="80"></el-table-column>
            <el-table-column label="操作" width="110">
              <template #default="scope"><el-button link type="primary" :disabled="Number(scope.row.availableQuantity || 0) <= 0 || !canEditCompletion" @click="addRepairPlanLine(scope.row)">加入本批</el-button></template>
            </el-table-column>
          </el-table>
          <el-form v-if="canEditCompletion" :model="repairBatch" label-width="90px" class="batch-form">
            <el-row :gutter="12">
              <el-col :md="6"><el-form-item label="批次编号"><el-input :model-value="repairBatch.batchCode || '保存后自动生成'" disabled></el-input></el-form-item></el-col>
              <el-col :md="6"><el-form-item label="回货日期"><el-date-picker v-model="repairBatch.returnDate" type="date" value-format="YYYY-MM-DD" style="width:100%"></el-date-picker></el-form-item></el-col>
              <el-col :md="12"><el-form-item label="批次备注"><el-input v-model="repairBatch.remark"></el-input></el-form-item></el-col>
            </el-row>
          </el-form>
          <el-table max-height="520" v-if="repairBatches.length" :data="repairBatches" border size="small" class="saved-batch-table return-table">
            <el-table-column prop="batch.batchCode" label="回货批次" width="170"></el-table-column>
            <el-table-column prop="batch.returnDate" label="回货日期" width="120"></el-table-column>
            <el-table-column label="数量" width="90"><template #default="scope">{{ batchQuantity(scope.row) }}</template></el-table-column>
            <el-table-column label="状态" width="120"><template #default="scope"><el-tag :type="statusType(scope.row.batch.status)">{{ repairBatchStatusText(scope.row.batch.status) }}</el-tag></template></el-table-column>
            <el-table-column prop="batch.financerName" label="财务审核" width="100"></el-table-column>
            <el-table-column v-if="repairBatches.some(item => item.batch.handoverName || item.batch.reviewerName || item.batch.auditorName)" label="历史审核" width="180">
              <template #default="scope">{{ [scope.row.batch.handoverName, scope.row.batch.reviewerName, scope.row.batch.auditorName].filter(Boolean).join(' / ') || '-' }}</template>
            </el-table-column>
            <el-table-column label="入库单号" min-width="180">
              <template #default="scope">
                <el-button v-if="scope.row.batch.inboundBillCode" link type="primary" @click="openRepairInbound(scope.row.batch)">
                  {{ scope.row.batch.inboundBillCode }}
                </el-button>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="290" fixed="right">
              <template #default="scope">
                <el-button v-if="Number(scope.row.batch.status) == 0 && canManageRepairDraft(scope.row.batch)" link type="primary" @click="editRepairBatch(scope.row)">编辑</el-button>
                <el-button v-if="[0,11,21].includes(Number(scope.row.batch.status)) && canFinanceAction" link type="success" @click="auditRepairBatch(scope.row)">财务审核入库</el-button>
                <el-button v-if="[0,11,21].includes(Number(scope.row.batch.status)) && canManageRepairDraft(scope.row.batch)" link type="danger" @click="cancelRepairBatch(scope.row)">取消</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <el-table max-height="520" v-if="template == 'tolling' && tollingBatches.length" :data="tollingBatches" border size="small" class="saved-batch-table return-table">
          <el-table-column prop="batch.batchCode" label="已保存批次" width="180"></el-table-column>
          <el-table-column prop="batch.returnDate" label="回货日期" width="160"></el-table-column>
          <el-table-column prop="batch.receiverName" label="收货人" width="100"></el-table-column>
          <el-table-column prop="batch.deliveryNo" label="送货单号" width="130"></el-table-column>
          <el-table-column label="明细数/数量"><template #default="scope">{{ scope.row.details.length }} 条 / {{ batchQuantity(scope.row) }}</template></el-table-column>
          <el-table-column label="处理状态" width="150">
            <template #default>
              <el-tag :type="tollingProcessStatusType()">{{ tollingProcessStatusText() }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="210" fixed="right">
            <template #default="scope">
              <el-button link type="primary" @click="showTollingBatchDetails(scope.row)">查看明细</el-button>
              <el-button v-if="canEditCompletion" link type="primary" @click="editTollingBatch(scope.row)">编辑</el-button>
              <el-button v-if="canEditCompletion" link type="danger" @click="removeTollingBatch(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <template v-if="template != 'tolling' || canEditCompletion">
          <el-divider v-if="template == 'tolling'" content-position="left">当前批次录入</el-divider>
          <el-form v-if="template == 'tolling'" :model="tollingBatch" label-width="100px" class="batch-form">
            <el-row :gutter="10">
              <el-col :md="5"><el-form-item label="批次编号"><el-input v-model="tollingBatch.batchCode" placeholder="留空自动生成"></el-input></el-form-item></el-col>
              <el-col :md="5"><el-form-item label="回货日期"><el-date-picker v-model="tollingBatch.returnDate" type="date" value-format="YYYY-MM-DD" style="width:100%"></el-date-picker></el-form-item></el-col>
              <el-col :md="5"><el-form-item label="收货人"><el-input v-model="tollingBatch.receiverName"></el-input></el-form-item></el-col>
              <el-col :md="5"><el-form-item label="送货单号"><el-input v-model="tollingBatch.deliveryNo"></el-input></el-form-item></el-col>
              <el-col :md="4"><el-form-item label="批次备注"><el-input v-model="tollingBatch.remark"></el-input></el-form-item></el-col>
            </el-row>
          </el-form>
          <div class="table-toolbar">
          <el-button type="primary" plain icon="Plus" :disabled="!canEditCompletion" @click="addReturnLine">新增回货入库明细</el-button>
          <el-button v-if="!isRepairBatchMode" type="success" plain icon="CopyDocument" :disabled="!canEditCompletion || sourceDetails.length === 0" @click="openQuickReturnDialog">按原出库货品快速添加</el-button>
          <el-button v-else type="success" plain icon="CopyDocument" :disabled="!canEditCompletion" @click="addAllRepairPlanLines">添加全部可回明细</el-button>
          <el-button type="warning" plain icon="Upload" :disabled="!canEditCompletion" @click="openImportDialog">入库批量导入</el-button>
          </div>
          <el-table max-height="520" :data="returnDetails" stripe border size="small" class="return-table" style="width:100%;">
          <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
          <el-table-column prop="storeCode" label="入库库房" width="130">
            <template #default="scope">
              <el-select v-model="scope.row.storeCode" :disabled="!canEditCompletion" style="width:100%">
                <el-option v-for="item in dict.stores" :key="item.value" :label="item.label || item.name" :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="channel" label="入库渠道" width="130">
            <template #default="scope">
              <el-select v-model="scope.row.channel" :disabled="!canEditCompletion" style="width:100%">
                <el-option v-for="item in dict.channels" :key="item.value" :label="item.label || item.name" :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="serialCode" label="回货批次号" width="150">
            <template #default="scope"><el-input v-model="scope.row.serialCode" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="brandSerialCode" label="品牌批次号" width="140">
            <template #default="scope"><el-input v-model="scope.row.brandSerialCode" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="detailCode" label="系统款号" width="210">
            <template #default="scope">
              <el-input v-model="scope.row.detailCode" :disabled="!canEditCompletion || scope.row._skuResolving || isRepairBatchMode"
                @change="resolveReturnSku(scope.row, true, true)"></el-input>
              <div v-if="scope.row._skuResolving" class="sku-hint">正在匹配款式...</div>
              <div v-else-if="scope.row._skuError" class="sku-hint sku-hint-error">{{ scope.row._skuError }}</div>
              <el-tooltip v-else-if="scope.row.detailName" :content="skuSummary(scope.row)" placement="top">
                <div class="sku-hint sku-hint-success">{{ skuSummary(scope.row) }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column v-if="template == 'tolling'" label="计划成品" width="180">
            <template #default="scope">
              <el-select v-model="scope.row._planID" :disabled="!canEditCompletion" clearable placeholder="非计划成品" style="width:100%" @change="applyPlanToReturn(scope.row)">
                <el-option v-for="item in tollingPlanRows" :key="item.id" :label="item.detailCode + '/' + item.detailName" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column v-if="isRepairBatchMode" label="预计维修明细" width="210">
            <template #default="scope">
              <el-select v-model="scope.row._planTempID" :disabled="!canEditCompletion" placeholder="请选择预计明细" style="width:100%" @change="applyRepairPlanToReturn(scope.row)">
                <el-option v-for="item in repairPlans" :key="item.plan.id" :disabled="Number(item.availableQuantity || 0) <= 0 && item.plan.id != scope.row._planTempID"
                  :label="item.plan.detailCode + '/' + item.plan.serialCode + '/可回' + item.availableQuantity" :value="item.plan.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="certNumber" label="证书号" width="120">
            <template #default="scope"><el-input v-model="scope.row.certNumber" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="className" label="计价类型" width="110">
            <template #default="scope">
              <el-select v-model="scope.row.className" :disabled="!canEditCompletion" @change="onClassNameChange(scope.row)">
                <el-option label="按克" value="按克"></el-option>
                <el-option label="按件" value="按件"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="stockNumber" label="数量" width="90">
            <template #default="scope"><el-input v-model="scope.row.stockNumber" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'stockNumber')"></el-input></template>
          </el-table-column>
          <el-table-column prop="weight" label="克重" width="100">
            <template #default="scope"><el-input v-model="scope.row.weight" :disabled="!canEditCompletion" @change="normalizeNumberField(scope.row, 'weight')"></el-input></template>
          </el-table-column>
          <el-table-column prop="goldWeight" label="金重" width="100">
            <template #default="scope"><el-input v-model="scope.row.goldWeight" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'goldWeight')"></el-input></template>
          </el-table-column>
          <el-table-column prop="goldInPrice" label="金单价" width="105">
            <template #default="scope"><el-input v-model="scope.row.goldInPrice" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'goldInPrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="goldInTaxPrice" label="含税金单价" width="115">
            <template #default="scope"><el-input v-model="scope.row.goldInTaxPrice" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'goldInTaxPrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="laborUnitPrice" label="克工费" width="100">
            <template #default="scope"><el-input v-model="scope.row.laborUnitPrice" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'laborUnitPrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="laborUnitTaxPrice" label="含税克工费" width="115">
            <template #default="scope"><el-input v-model="scope.row.laborUnitTaxPrice" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'laborUnitTaxPrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="laborPiecePrice" label="件工费" width="100">
            <template #default="scope"><el-input v-model="scope.row.laborPiecePrice" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'laborPiecePrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="laborPieceTaxPrice" label="含税件工费" width="115">
            <template #default="scope"><el-input v-model="scope.row.laborPieceTaxPrice" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'laborPieceTaxPrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="otherPiecePrice" label="其他费用" width="105">
            <template #default="scope"><el-input v-model="scope.row.otherPiecePrice" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'otherPiecePrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="otherPieceTaxPrice" label="含税其他费" width="115">
            <template #default="scope"><el-input v-model="scope.row.otherPieceTaxPrice" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'otherPieceTaxPrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="stoneBoundPrice" label="镶嵌物费用" width="115">
            <template #default="scope"><el-input v-model="scope.row.stoneBoundPrice" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'stoneBoundPrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="stoneBoundTaxPrice" label="含税镶嵌费" width="115">
            <template #default="scope"><el-input v-model="scope.row.stoneBoundTaxPrice" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'stoneBoundTaxPrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="noTaxPurchasePrice" label="不含税采购价" width="125">
            <template #default="scope"><el-input v-model="scope.row.noTaxPurchasePrice" :disabled="!canEditCompletion || isByWeightPriced(scope.row)" @change="itemChange(scope.row, 'noTaxPurchasePrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="taxPrice" label="税额" width="105">
            <template #default="scope"><el-input v-model="scope.row.taxPrice" disabled></el-input></template>
          </el-table-column>
          <el-table-column prop="purchasePrice" label="含税采购价" width="120">
            <template #default="scope"><el-input v-model="scope.row.purchasePrice" :disabled="!canEditCompletion || isByWeightPriced(scope.row)" @change="itemChange(scope.row, 'purchasePrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="useBrandPrice" label="品牌使用费" width="115">
            <template #default="scope"><el-input v-model="scope.row.useBrandPrice" :disabled="!canEditCompletion" @change="itemChange(scope.row, 'useBrandPrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="sellPrice" label="计划售价" width="110">
            <template #default="scope"><el-input v-model="scope.row.sellPrice" :disabled="!canEditCompletion" @change="normalizeNumberField(scope.row, 'sellPrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="180">
            <template #default="scope"><el-input v-model="scope.row.remark" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column v-if="canEditCompletion" label="操作" width="80" align="center">
            <template #default="scope">
              <el-button type="primary" link size="small" @click="removeDetailLine(scope.row)">删除</el-button>
            </template>
          </el-table-column>
          </el-table>
        </template>
      </template>

      <template v-else>
        <el-divider content-position="left">
          融金回款结案
          <span class="settlement-no-stock-tip">（回款记录不会生成入库流水）</span>
        </el-divider>
        <div class="table-toolbar">
          <el-button type="primary" plain icon="Plus" :disabled="!canEditCompletion" @click="addSettlementLine">新增回款记录</el-button>
        </div>
        <el-table max-height="520" :data="settlementDetails" stripe border size="small" class="return-table" style="width:100%;">
          <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
          <el-table-column prop="serialCode" label="关联批次号" width="140">
            <template #default="scope"><el-input v-model="scope.row.serialCode" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="storeCode" label="库房" width="110">
            <template #default="scope"><el-input v-model="scope.row.storeCode" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="channel" label="渠道" width="110">
            <template #default="scope"><el-input v-model="scope.row.channel" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="weight" label="融金克重" width="120">
            <template #default="scope"><el-input v-model="scope.row.weight" :disabled="!canEditCompletion" @change="normalizeNumberField(scope.row, 'weight')"></el-input></template>
          </el-table-column>
          <el-table-column prop="goldWeight" label="融金金重" width="120">
            <template #default="scope"><el-input v-model="scope.row.goldWeight" :disabled="!canEditCompletion" @change="normalizeNumberField(scope.row, 'goldWeight')"></el-input></template>
          </el-table-column>
          <el-table-column prop="productPrice" label="回款金额" width="130">
            <template #default="scope"><el-input v-model="scope.row.productPrice" :disabled="!canEditCompletion" @change="normalizeNumberField(scope.row, 'productPrice')"></el-input></template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="180">
            <template #default="scope"><el-input v-model="scope.row.remark" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column v-if="canEditCompletion" label="操作" width="80" align="center">
            <template #default="scope">
              <el-button type="primary" link size="small" @click="removeDetailLine(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </template>

        </template>
      </el-tab-pane>
      <el-tab-pane v-if="outboundFlows.length || returnInFlows.length" label="库存流水" name="flows">
        <template v-if="activeTab === 'flows'">
    <template v-if="outboundFlows.length > 0">
      <el-divider content-position="left">已出库流水</el-divider>
      <el-table max-height="520" :data="outboundFlows" stripe border size="small" style="width:100%;">
        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
        <el-table-column prop="billCode" label="出库单号" width="140"></el-table-column>
        <el-table-column prop="billType" label="流水类型" width="120"></el-table-column>
        <el-table-column prop="serialCode" label="批次号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailCode" label="系统款号" width="130"></el-table-column>
        <el-table-column prop="storeCode" label="库房" width="90"></el-table-column>
        <el-table-column prop="channel" label="渠道" width="90"></el-table-column>
        <el-table-column prop="stockNumber" label="数量" width="90"></el-table-column>
        <el-table-column prop="stockReason" label="原因" min-width="180" show-overflow-tooltip></el-table-column>
      </el-table>
    </template>

    <template v-if="isReturnBill && requiresReturn && returnInFlows.length > 0">
      <el-divider content-position="left">回货入库流水</el-divider>
      <el-table max-height="520" :data="returnInFlows" stripe border size="small" style="width:100%;">
        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
        <el-table-column label="状态" width="110" align="center">
          <template #default="scope">
            <el-tag :type="returnInFlowStatusType(scope.row)">{{ returnInFlowStatusText(scope.row) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="billCode" label="入库单号" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="billType" label="流水类型" width="120"></el-table-column>
        <el-table-column prop="serialCode" label="批次号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailCode" label="系统款号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailName" label="名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeCode" label="库房" width="90"></el-table-column>
        <el-table-column prop="channel" label="渠道" width="90"></el-table-column>
        <el-table-column prop="stockNumber" label="数量" width="90"></el-table-column>
        <el-table-column prop="productPrice" label="入库成本" width="110"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip></el-table-column>
      </el-table>
    </template>

        </template>
      </el-tab-pane>
    </el-tabs>

    <div class="actions">
      <el-button v-if="!id" type="primary" icon="Promotion" @click="submitCreate">提交出库申请</el-button>
      <el-button v-if="isReturnBill && canEditCompletion" type="primary" plain icon="DocumentChecked" @click="saveCompletion">{{ template == 'tolling' || isRepairBatchMode ? '保存回货批次' : '保存待回货明细' }}</el-button>
      <el-button v-if="isReturnBill && template == 'tolling' && bill.status == 2" type="success" icon="Promotion" @click="submitTollingForReview">提交全部回货审核</el-button>
      <el-button v-if="canCancelApplication" type="danger" plain icon="CircleClose" @click="cancelApplication">取消申请</el-button>
      <el-button v-if="id && bill.status == 0 && !isRepairBatchMode && (isReturnBill ? canRepairInventoryAction : canDepartmentHeadAction)" type="primary" icon="Check" @click="approveStage">{{ isReturnBill ? '待回货确认' : '部门负责人审核' }}</el-button>
      <el-button v-if="id && bill.status == 11 && template == 'gold' && !isRepairBatchMode && canFinanceAction" type="warning" icon="EditPen" @click="reviewStage">财务复核</el-button>
      <el-button v-if="canAuditStage" type="success" icon="Finished" @click="auditStage">{{ isReturnBill ? '完成待回货' : '库管审核出库' }}</el-button>
      <el-button v-if="id && !isReturnBill && bill.status == 1" type="success" icon="Tickets" @click="openReturnBill">打开待回货单</el-button>
      <el-button v-if="id && bill.status == 1 && !isRepairBatchMode" type="success" plain icon="Tickets" @click="openStockDetail">库存明细</el-button>
      <el-button @click="$router.push('/stock/bills/pendingReturn')">返回</el-button>
    </div>

    <el-dialog title="添加出库货品" v-model="showAddDialog" style="max-width:1200px; width:100%;" destroy-on-close>
      <el-form :model="searchForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="所属公司">
              <el-tree-select v-model="bill.companyId" :data="companys" check-strictly :render-after-expand="false"
                style="width:100%" :disabled="!!currentCompanyId()" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="批次号">
              <el-input v-model="searchForm.serialCode" clearable placeholder="支持多个批次号；可用逗号、分号、空格、换行分隔" @keyup.enter="searchSource"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="系统款号">
              <el-input v-model="searchForm.detailCode" clearable @keyup.enter="searchSource"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="品牌款号">
              <el-input v-model="searchForm.brandModelCode" clearable @keyup.enter="searchSource"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="库房">
              <el-select v-model="searchForm.storeCode" clearable placeholder="全部库房" style="width:100%">
                <el-option v-for="item in dict.stores" :key="item.value" :label="item.label || item.name" :value="item.value"
                  :disabled="template == 'tolling' && !canUseOtherTollingStore && !isDefaultTollingSourceStore(item)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="渠道">
              <el-select v-model="searchForm.channel" clearable placeholder="全部渠道" style="width:100%">
                <el-option v-for="item in dict.channels" :key="item.value" :label="item.label || item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="dialog-actions">
          <el-button type="primary" icon="Search" :loading="searchLoading" @click="searchSource">查询货品</el-button>
          <el-button @click="resetSearchForm">重置</el-button>
          <el-button type="success" icon="Plus" :disabled="searchSelectedItems.length === 0" @click="batchAddSource">批量添加 ({{ searchSelectedItems.length }})</el-button>
        </div>
      </el-form>

      <el-divider></el-divider>
      <el-table ref="sourceResultTable" :data="sourceResults" border size="small" max-height="420" v-loading="searchLoading"
        @selection-change="handleSearchSelectionChange" style="width:100%;">
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
        <el-table-column prop="billCode" label="库存单号" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="serialCode" label="批次号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailCode" label="系统款号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="brandModelCode" label="品牌款号" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailName" label="名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeCode" label="库房" width="90"></el-table-column>
        <el-table-column prop="channel" label="渠道" width="90"></el-table-column>
        <el-table-column prop="stockRemain" label="可用数" width="90"></el-table-column>
        <el-table-column prop="weight" label="克重" width="90"></el-table-column>
        <el-table-column prop="goldWeight" label="金重" width="90"></el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="showAddDialog = false">关闭</el-button>
      </template>
    </el-dialog>

    <el-dialog title="按原出库货品快速添加回货入库" v-model="showQuickReturnDialog" style="max-width:1200px; width:100%;" destroy-on-close>
      <el-table :data="sourceDetails" border stripe size="small" max-height="460"
        @selection-change="handleQuickReturnSelectionChange" style="width:100%;">
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
        <el-table-column prop="billCode" label="出库单号" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="serialCode" label="批次号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="brandSerialCode" label="品牌批次号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailCode" label="系统款号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="brandModelCode" label="品牌款号" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailName" label="名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeCode" label="库房" width="90"></el-table-column>
        <el-table-column prop="channel" label="渠道" width="90"></el-table-column>
        <el-table-column prop="stockNumber" label="数量" width="90"></el-table-column>
        <el-table-column prop="weight" label="克重" width="90"></el-table-column>
        <el-table-column prop="goldWeight" label="金重" width="90"></el-table-column>
        <el-table-column prop="productPrice" label="成本" width="100"></el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="showQuickReturnDialog = false">关闭</el-button>
        <el-button type="primary" icon="Plus" :disabled="quickReturnSelectedItems.length === 0" @click="batchAddReturnFromSource">生成入库明细 ({{ quickReturnSelectedItems.length }})</el-button>
      </template>
    </el-dialog>

    <el-dialog title="批量导入回货入库明细" v-model="showImportDialog" style="max-width:560px; width:100%;" destroy-on-close>
      <div style="text-align:center;">
        <h4>上传前请检查文件格式模板，解析结果将追加到回货入库明细中</h4>
        <el-alert v-if="isRepairBatchMode" type="info" :closable="false" show-icon style="margin:12px 0; text-align:left;">
          <template #title>维修回货请填写“原出库批次号”，系统将结合系统款号自动匹配预计维修明细；“回货批次号”是本次实际入库批次号，两者可以不同。</template>
        </el-alert>
        <br>
        <el-upload v-loading="importLoading" class="upload-box" ref="importUpload" action="#" drag
          :on-exceed="handleImportExceed" :file-list="importFileList" :http-request="submitImportUpload"
          :auto-upload="true" :limit="1">
          <el-icon style="font-size:3em;">
            <UploadFilled />
          </el-icon>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip">
            注：名称、品牌、工厂及品牌款号会按系统款号自动补齐；按件计价需填写采购价，按克计价由系统重算。导入前请删除示例行
          </div>
        </el-upload>
        <el-link type="primary" @click="downloadImportTemplate">点击下载回货入库导入模板.xlsx</el-link>
      </div>
      <template #footer>
        <el-button @click="showImportDialog = false">关闭</el-button>
      </template>
    </el-dialog>

    <el-dialog title="送料加工差异结案" v-model="showVarianceDialog" width="560px" destroy-on-close>
      <el-alert title="差异结案只记录差异，不会回冲已送料库存，也不会自动生成损耗单。" type="warning" :closable="false" show-icon style="margin-bottom:18px;"></el-alert>
      <el-form :model="varianceForm" label-width="90px">
        <el-form-item label="差异原因" required>
          <el-input v-model="varianceForm.varianceReason" maxlength="200" show-word-limit placeholder="例如：加工损耗、超量交付、替代款式"></el-input>
        </el-form-item>
        <el-form-item label="责任方" required>
          <el-select v-model="varianceForm.varianceResponsibility" allow-create filterable default-first-option style="width:100%" placeholder="请选择或输入责任方">
            <el-option label="加工方" value="加工方"></el-option>
            <el-option label="我方" value="我方"></el-option>
            <el-option label="双方确认" value="双方确认"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="差异说明" required>
          <el-input v-model="varianceForm.varianceRemark" type="textarea" :rows="4" maxlength="500" show-word-limit placeholder="请说明少回、多回或非计划成品的处理结论"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showVarianceDialog = false">取消</el-button>
        <el-button type="danger" @click="confirmTollingVariance">确认差异结案并提交审核</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="showTollingDetailDialog" :title="`回货批次明细 - ${selectedTollingBatchHeader.batchCode || ''}`"
      width="96%" style="max-width:1500px;" destroy-on-close @closed="selectedTollingBatch = null">
      <el-descriptions :column="5" border size="small" class="tolling-detail-summary">
        <el-descriptions-item label="回货批次">{{ selectedTollingBatchHeader.batchCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="回货日期">{{ selectedTollingBatchHeader.returnDate || '-' }}</el-descriptions-item>
        <el-descriptions-item label="收货人">{{ selectedTollingBatchHeader.receiverName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="送货单号">{{ selectedTollingBatchHeader.deliveryNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="处理状态">
          <el-tag :type="tollingProcessStatusType()">{{ tollingProcessStatusText() }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="批次备注" :span="5">{{ selectedTollingBatchHeader.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="selectedTollingDetailRows" row-key="_rowKey" stripe border size="small"
        max-height="560" empty-text="该批次没有可展示的回货明细" style="width:100%; margin-top:14px;">
        <el-table-column type="index" label="序号" width="55" align="center" fixed="left"></el-table-column>
        <el-table-column label="处理状态" width="150" fixed="left">
          <template #default>
            <el-tag :type="tollingProcessStatusType()">{{ tollingProcessStatusText() }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-for="column in savedTollingDetailColumns" :key="column.prop"
          :prop="column.prop" :label="column.label" :width="column.width" :min-width="column.minWidth"
          show-overflow-tooltip></el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="showTollingDetailDialog = false">关闭</el-button>
      </template>
    </el-dialog>

    <pending-return-help-dialog
      v-model="showHelpDialog"
      :template="template"
      :completion-mode="completionMode"
    ></pending-return-help-dialog>
  </el-card>
</template>

<script>
import {
  fetchBillCode,
  fetchGroupBySerialCode,
  fetchPendingReturnDetail,
  submitPendingReturn,
  approvePendingReturn,
  confirmPendingReturn,
  cancelPendingReturn,
  cancelPendingReturnDetail,
  reviewPendingReturn,
  savePendingReturnCompletion,
  savePendingTollingBatch,
  deletePendingTollingBatch,
  submitPendingTollingReturn,
  savePendingRepairBatch,
  auditPendingRepairBatch,
  cancelPendingRepairBatch,
  auditPendingReturn,
  fetchPendingReturnImportTemplate,
  parsePendingReturnImport
} from "@/api/stock";
import { fetchSkuByDetailCode, fetchSkuList } from "@/api/product";
import { fetchPurchaseSupplier } from "@/api/purchase";
import { uploader } from "@/api/subupload";
import PendingReturnHelpDialog from "./PendingReturnHelpDialog.vue";

export default {
  name: "PendingReturnDetail",
  components: { PendingReturnHelpDialog },
  data() {
    return {
      id: "",
      activeTab: "outbound",
      tabsInitialized: false,
      template: "repair",
      completionMode: "return",
      bill: {},
      sourceBill: null,
      details: [],
      sourcePrebounds: [],
      sourceBounds: [],
      returnInBill: null,
      returnInBillCode: "",
      returnInPrebounds: [],
      returnInBounds: [],
      bounds: [],
      suppliers: [],
      tolling: {},
      tollingPlans: [],
      tollingBatches: [],
      tollingProgress: {},
      inboundState: "",
      tollingBatch: {},
      repairPlans: [],
      repairBatches: [],
      repairProgress: {},
      repairBatch: {},
      showVarianceDialog: false,
      showTollingDetailDialog: false,
      selectedTollingBatch: null,
      showHelpDialog: false,
      varianceForm: {
        varianceReason: "",
        varianceResponsibility: "",
        varianceRemark: ""
      },
      showAddDialog: false,
      showQuickReturnDialog: false,
      showImportDialog: false,
      importLoading: false,
      importFileList: [],
      searchForm: {
        serialCode: "",
        detailCode: "",
        brandModelCode: "",
        storeCode: "",
        channel: ""
      },
      sourceResults: [],
      searchSelectedItems: [],
      quickReturnSelectedItems: [],
      searchLoading: false,
      settlementAddConfirmed: false,
      companys: [],
      dict: {
        stores: [],
        channels: []
      }
    };
  },
  computed: {
    isReturnBill() {
      return (this.bill.billCode || this.id || "").endsWith("-R");
    },
    isLocked() {
      return !!this.id;
    },
    canEditCompletion() {
      if (this.template == "tolling") return this.isReturnBill && Number(this.bill.status) == 2;
      if (this.isRepairBatchMode) {
        if (Number(this.bill.status) != 2 || !this.repairBatch.id) return Number(this.bill.status) == 2;
        return Number(this.repairBatch.status) == 0 && this.canManageRepairDraft(this.repairBatch);
      }
      return this.isReturnBill && this.bill.status != 1 && this.bill.status != -1;
    },
    isRepairBatchMode() {
      return this.template == "repair" && this.isReturnBill && this.repairPlans.length > 0;
    },
    canDepartmentHeadAction() {
      const user = this.$store.getters.getUserInfo || {};
      const roles = Array.isArray(user.roles) ? user.roles.map(item => String(item).toLowerCase()) : [];
      return user.isAdminer === true || roles.includes("role_department_head") || roles.includes("role_super_administrator") || roles.includes("admin");
    },
    canCancelApplication() {
      if (!this.id || this.isReturnBill || ![0, 11, 21].includes(Number(this.bill.status))) return false;

      const user = this.$store.getters.getUserInfo || {};
      const userId = user.userID || user.id || "";
      const isOwner = !!userId && String(this.bill.createUserID || "").toLowerCase() === String(userId).toLowerCase();
      const roles = Array.isArray(user.roles) ? user.roles.map(item => String(item).toLowerCase()) : [];
      const hasInventoryRole = roles.includes("role_sc_inventory");
      const isAdmin = user.isAdminer === true || roles.includes("role_super_administrator") || roles.includes("admin");
      return isOwner || hasInventoryRole || isAdmin;
    },
    canUseOtherTollingStore() {
      const user = this.$store.getters.getUserInfo || {};
      const roles = Array.isArray(user.roles) ? user.roles.map(item => String(item).toLowerCase()) : [];
      return user.isAdminer === true || roles.includes("role_sc_inventory") || roles.includes("role_super_administrator") || roles.includes("admin");
    },
    canRepairInventoryAction() {
      const user = this.$store.getters.getUserInfo || {};
      const roles = Array.isArray(user.roles) ? user.roles.map(item => String(item).toLowerCase()) : [];
      return user.isAdminer === true || roles.includes("role_sc_inventory") || roles.includes("role_super_administrator") || roles.includes("admin");
    },
    canFinanceAction() {
      const user = this.$store.getters.getUserInfo || {};
      const roles = Array.isArray(user.roles) ? user.roles.map(item => String(item).toLowerCase()) : [];
      return user.isAdminer === true || roles.includes("role_finance_auditor") || roles.includes("role_super_administrator") || roles.includes("admin");
    },
    canAuditStage() {
      if (!this.id || this.isRepairBatchMode) return false;
      const status = Number(this.bill.status);
      if (this.template == "gold") return status == 21 && this.canRepairInventoryAction;
      if (![11, 21].includes(status)) return false;
      return this.isReturnBill ? this.canFinanceAction : this.canRepairInventoryAction;
    },
    activeSourceDetailCount() {
      return this.sourceDetails.filter(item => String(item.status || "0") == "0").length;
    },
    requiresReturn() {
      return this.completionMode == "return";
    },
    tollingPlanRows() {
      return this.tollingPlans || [];
    },
    savedTollingDetailColumns() {
      return [
        { prop: "detailCode", label: "系统款号", width: 150 },
        { prop: "detailName", label: "名称", minWidth: 180 },
        { prop: "_planLabel", label: "计划成品", width: 210 },
        { prop: "serialCode", label: "回货批次号", width: 150 },
        { prop: "brandSerialCode", label: "品牌批次号", width: 140 },
        { prop: "storeCode", label: "入库库房", width: 130 },
        { prop: "channel", label: "入库渠道", width: 130 },
        { prop: "certNumber", label: "证书号", width: 120 },
        { prop: "className", label: "计价类型", width: 110 },
        { prop: "stockNumber", label: "数量", width: 90 },
        { prop: "weight", label: "克重", width: 100 },
        { prop: "goldWeight", label: "金重", width: 100 },
        { prop: "goldInPrice", label: "金单价", width: 105 },
        { prop: "goldInTaxPrice", label: "含税金单价", width: 115 },
        { prop: "laborUnitPrice", label: "克工费", width: 100 },
        { prop: "laborUnitTaxPrice", label: "含税克工费", width: 115 },
        { prop: "laborPiecePrice", label: "件工费", width: 100 },
        { prop: "laborPieceTaxPrice", label: "含税件工费", width: 115 },
        { prop: "otherPiecePrice", label: "其他费用", width: 105 },
        { prop: "otherPieceTaxPrice", label: "含税其他费", width: 115 },
        { prop: "stoneBoundPrice", label: "镶嵌物费用", width: 115 },
        { prop: "stoneBoundTaxPrice", label: "含税镶嵌费", width: 115 },
        { prop: "noTaxPurchasePrice", label: "不含税采购价", width: 125 },
        { prop: "taxPrice", label: "税额", width: 105 },
        { prop: "purchasePrice", label: "含税采购价", width: 120 },
        { prop: "productPrice", label: "入库成本", width: 110 },
        { prop: "useBrandPrice", label: "品牌使用费", width: 115 },
        { prop: "sellPrice", label: "计划售价", width: 110 },
        { prop: "remark", label: "明细备注", minWidth: 180 }
      ];
    },
    selectedTollingBatchHeader() {
      return this.selectedTollingBatch?.batch || {};
    },
    selectedTollingDetailRows() {
      const plansById = new Map();
      const plansByCode = new Map();
      this.tollingPlanRows.forEach(plan => {
        const id = String(plan.id || plan.ID || "").trim().toLowerCase();
        const code = String(plan.detailCode || "").trim().toLowerCase();
        if (id) plansById.set(id, plan);
        if (code) plansByCode.set(code, plan);
      });
      const rows = [];
      const batch = this.selectedTollingBatch?.batch || {};
      (this.selectedTollingBatch?.details || []).forEach((line, detailIndex) => {
        const detail = line.detail || {};
        const planId = String(line.planID || line.planId || "").trim().toLowerCase();
        const detailCode = String(detail.detailCode || "").trim().toLowerCase();
        const plan = plansById.get(planId) || plansByCode.get(detailCode);
        const planLabel = plan
          ? [plan.detailCode, plan.detailName].filter(Boolean).join("/")
          : "非计划成品";
        rows.push({
          ...detail,
          _rowKey: line.linkID || line.linkId || detail.id || detail.ID || `${batch.id || "batch"}-${detailIndex}`,
          _planLabel: planLabel
        });
      });
      return rows;
    },
    sourceBillCode() {
      return this.sourceBill?.billCode || (this.isReturnBill ? (this.bill.netCode || (this.bill.billCode || "").replace(/-R$/, "")) : this.bill.billCode);
    },
    sourceDetails() {
      if (this.isReturnBill) {
        return this.sourcePrebounds.length > 0 ? this.sourcePrebounds : this.sourceBounds;
      }
      return this.details.filter(item => item.processLineType == "source-out");
    },
    returnDetails() {
      return this.details.filter(item => item.processLineType == "return-in");
    },
    settlementDetails() {
      return this.details.filter(item => item.processLineType == "settlement");
    },
    completionDetails() {
      return this.requiresReturn ? this.returnDetails : this.settlementDetails;
    },
    outboundFlows() {
      if (this.isReturnBill) return this.sourceBounds;
      return this.bounds.filter(item => Number(item.stockNumber || 0) < 0);
    },
    returnInFlows() {
      const bounds = (this.returnInBounds || []).map(item => ({ ...item, flowSource: "bound" }));
      const boundKeys = new Set(bounds.map(item => this.returnInFlowKey(item)));
      const prebounds = (this.returnInPrebounds || [])
        .filter(item => !boundKeys.has(this.returnInFlowKey(item)))
        .map(item => ({ ...item, flowSource: "prebound" }));
      return prebounds.concat(bounds);
    }
  },
  created() {
    this.id = this.$route.query.id || "";
    this.template = this.$route.query.template || "repair";
    this.activeTab = this.template == "tolling" ? "basic" : "outbound";
    this.completionMode = this.template == "gold" ? "cash" : "return";
    this.initBill();
    this.initTollingData();
    if (this.id) {
      this.loadDetail();
    } else {
      this.initBillCode();
    }
  },
  mounted() {
    this.$kaung.companys().then((res) => {
      this.companys = res || [];
      if (!this.bill.companyId && this.companys.length > 0) {
        this.bill.companyId = this.$store.getters.getUserInfo?.companyID || this.companys[0].id;
      }
    });
    this.$kaung.dictionary("stock", "store").then(res => {
      this.dict.stores = res || [];
      if (!this.id && this.template == "tolling") {
        const semi = this.dict.stores.find(item => (item.value || item.name || item.label) == "半成品库");
        this.searchForm.storeCode = semi?.value || semi?.name || "半成品库";
      }
    });
    this.$kaung.dictionary("stock", "channel").then(res => this.dict.channels = res || []);
    fetchPurchaseSupplier().then(res => this.suppliers = res.data || []);
  },
  methods: {
    isDefaultTollingSourceStore(item) {
      const storeCode = item?.value || item?.name || item?.label || "";
      return ["半成品库", "辅料库"].includes(storeCode);
    },
    canManageRepairDraft(batch) {
      if (this.canRepairInventoryAction) return true;
      const user = this.$store.getters.getUserInfo || {};
      const userId = String(user.userID || user.id || "").toLowerCase();
      if (!userId) return false;
      return [batch?.createUserID, this.bill.createUserID]
        .filter(Boolean)
        .some(id => String(id).toLowerCase() == userId);
    },
    initBill() {
      const user = this.$store.getters.getUserInfo || {};
      this.bill = {
        billType: "待回货流程",
        billSource: this.template + ":" + this.completionMode,
        billCode: "",
        billDate: this.$util.fmtDate(new Date(), "yyyy-MM-dd HH:mm:ss"),
        companyId: user.companyID || "",
        operatorName: user.realName || user.name || "",
        createUserName: user.realName || user.name || "",
        status: 0,
        reason: ""
      };
    },
    initTollingData() {
      this.tolling = {
        supplierID: "",
        supplierCode: "",
        supplierName: "",
        contactName: "",
        contactPhone: "",
        processorOrderNo: "",
        expectedReturnDate: "",
        varianceClosed: false,
        varianceReason: "",
        varianceResponsibility: "",
        varianceRemark: ""
      };
      this.tollingPlans = [];
      this.tollingBatches = [];
      this.tollingProgress = {};
      this.inboundState = "";
      this.resetTollingBatch();
      this.repairPlans = [];
      this.repairBatches = [];
      this.repairProgress = {};
      this.resetRepairBatch();
    },
    resetTollingBatch() {
      const user = this.$store.getters.getUserInfo || {};
      this.tollingBatch = {
        id: "",
        batchCode: "",
        returnDate: this.$util.fmtDate(new Date(), "yyyy-MM-dd"),
        receiverName: user.realName || user.name || "",
        deliveryNo: "",
        remark: ""
      };
      if (this.template == "tolling" && this.isReturnBill) this.details = [];
    },
    resetRepairBatch() {
      this.repairBatch = {
        id: "",
        batchCode: "",
        returnDate: this.$util.fmtDate(new Date(), "yyyy-MM-dd"),
        status: 0,
        remark: ""
      };
      if (this.template == "repair" && this.isReturnBill) {
        this.details = this.details.filter(item => item.processLineType != "return-in");
      }
    },
    initBillCode() {
      const prefix = this.template == "gold" ? "DHH-RJ" : (this.template == "tolling" ? "DHH-SLJG" : "DHH-WX");
      fetchBillCode({ billType: "待回货流程", prev: prefix }).then((res) => {
        this.bill.billCode = res.data;
      });
    },
    loadDetail() {
      fetchPendingReturnDetail(this.id).then((res) => {
        const data = res.data || {};
        this.bill = data.bill || {};
        if (this.bill.billDate) this.bill.billDate = this.$util.fmtDate(this.bill.billDate, "yyyy-MM-dd HH:mm:ss");
        this.bill.companyId = this.bill.companyId || this.bill.companyID || "";
        this.sourceBill = data.sourceBill || null;
        this.template = data.template || this.sourceTemplate(this.bill.billSource);
        this.completionMode = data.completionMode || this.sourceMode(this.bill.billSource);
        this.details = (data.prebounds || []).map(item => item.processLineType == "return-in" ? this.initializeReturnLine(item) : item);
        this.bounds = data.bounds || [];
        this.sourcePrebounds = data.sourcePrebounds || [];
        this.sourceBounds = data.sourceBounds || [];
        this.returnInBill = data.returnInBill || null;
        this.returnInBillCode = data.returnInBillCode || "";
        this.returnInPrebounds = data.returnInPrebounds || [];
        this.returnInBounds = data.returnInBounds || [];
        this.tolling = data.tolling || this.tolling;
        this.tollingPlans = (data.tollingPlans || []).map(item => {
          const plan = item.plan || {};
          return {
            ...plan,
            _skuKeyword: plan.detailCode || "",
            actualQuantity: item.actualQuantity || 0,
            pendingQuantity: item.pendingQuantity || 0,
            varianceQuantity: item.varianceQuantity || 0
          };
        });
        this.tollingBatches = data.tollingBatches || [];
        this.tollingProgress = data.tollingProgress || {};
        this.inboundState = data.inboundState || "";
        this.repairPlans = data.repairPlans || [];
        this.repairBatches = data.repairBatches || [];
        this.repairProgress = data.repairProgress || {};
        if (!this.tabsInitialized) {
          this.activeTab = this.isReturnBill ? "return" : "outbound";
          this.tabsInitialized = true;
        }
        if (this.isRepairBatchMode) this.resetRepairBatch();
        if (this.template == "tolling" && this.isReturnBill) this.resetTollingBatch();
        if (this.returnDetails.length > 0) this.resolveAllReturnSkus(false, true);
      });
    },
    onTemplateChange() {
      this.activeTab = this.template == "tolling" ? "basic" : "outbound";
      this.completionMode = this.template == "gold" ? "cash" : "return";
      this.bill.billSource = this.template + ":" + this.completionMode;
      this.clearPendingData();
      this.initTollingData();
      this.initBillCode();
    },
    onCompletionChange() {
      if (this.template == "repair" || this.template == "tolling") this.completionMode = "return";
      this.bill.billSource = this.template + ":" + this.completionMode;
      this.clearPendingData();
    },
    onCompanyChange() {
      if (!this.id) this.clearPendingData();
    },
    clearPendingData() {
      this.details = [];
      this.sourceResults = [];
      this.searchSelectedItems = [];
      this.quickReturnSelectedItems = [];
      this.bill.channelCode = "";
      this.bill.storeCode = "";
      this.bill.netCode = "";
    },
    openAddDialog() {
      if (!this.currentCompanyId()) {
        this.$message({ type: "warning", message: "请选择所属公司" });
        return;
      }
      this.showAddDialog = true;
      this.resetSearchForm();
    },
    resetSearchForm() {
      const defaultStore = this.template == "tolling" ? "半成品库" : "";
      this.searchForm = { serialCode: "", detailCode: "", brandModelCode: "", storeCode: defaultStore, channel: "" };
      this.sourceResults = [];
      this.searchSelectedItems = [];
    },
    parseSerialCodes(rawText) {
      const normalized = (rawText || "")
        .replace(/[，；]/g, ",")
        .replace(/[\r\n\t；; ]+/g, ",");
      const list = normalized
        .split(",")
        .map(item => (item || "").trim())
        .filter(item => !!item);
      return Array.from(new Set(list));
    },
    searchSource() {
      if (!this.currentCompanyId()) {
        this.$message({ type: "warning", message: "请选择所属公司" });
        return;
      }
      if (!this.searchForm.serialCode && !this.searchForm.detailCode && !this.searchForm.brandModelCode && !this.searchForm.storeCode && !this.searchForm.channel) {
        this.$message({ type: "warning", message: "请至少填写一个查询条件" });
        return;
      }

      const serialCodes = this.searchForm.serialCode
        ? this.parseSerialCodes(this.searchForm.serialCode)
        : [];
      this.searchLoading = true;
      fetchGroupBySerialCode(
        serialCodes,
        this.currentCompanyId(),
        this.searchForm.detailCode || "",
        this.searchForm.storeCode || "",
        this.searchForm.channel || "",
        this.searchForm.brandModelCode || ""
      ).then((res) => {
        this.searchLoading = false;
        if (res.code == 200) {
          const rows = (res.data || []).filter(item => Number(item.stockRemain || 0) > 0);
          const isSerialOnly = serialCodes.length > 0 && !this.searchForm.detailCode && !this.searchForm.brandModelCode && !this.searchForm.storeCode && !this.searchForm.channel;
          const appended = this.appendSourceResults(rows);
          const target = rows.length == 1 ? (appended[0] || this.findSourceResult(rows[0])) : null;
          this.restoreSourceSelection();
          if (isSerialOnly && target) {
            this.$nextTick(() => {
              this.$refs.sourceResultTable?.toggleRowSelection(target, true);
            });
          }
        } else {
          this.$message({ type: "warning", message: res.content || "查询失败" });
        }
      }).catch(() => {
        this.searchLoading = false;
        this.$message({ type: "error", message: "查询失败" });
      });
    },
    handleSearchSelectionChange(selection) {
      this.searchSelectedItems = selection || [];
    },
    appendSourceResults(rows) {
      const exists = new Set(this.sourceResults.map(item => this.boundKey(item)));
      const appended = [];
      rows.forEach((item) => {
        const key = this.boundKey(item);
        if (!key || exists.has(key)) return;
        this.sourceResults.push(item);
        exists.add(key);
        appended.push(item);
      });
      return appended;
    },
    findSourceResult(row) {
      const key = this.boundKey(row);
      return this.sourceResults.find(item => this.boundKey(item) == key);
    },
    restoreSourceSelection() {
      const selected = new Set(this.searchSelectedItems.map(item => this.boundKey(item)));
      this.$nextTick(() => {
        this.sourceResults.forEach((row) => {
          if (selected.has(this.boundKey(row))) this.$refs.sourceResultTable?.toggleRowSelection(row, true);
        });
      });
    },
    boundKey(row) {
      return row?.id || row?.ID || row?.originalID || row?.originalId || "";
    },
    batchAddSource() {
      let added = 0;
      let duplicate = 0;
      this.searchSelectedItems.forEach((item) => {
        const sourceId = this.boundKey(item);
        if (!sourceId || this.sourceDetails.some(row => (row.originalID || row.originalId || row.id) == sourceId)) {
          duplicate += 1;
          return;
        }
        this.details.push(this.copySourceDetail(item));
        added += 1;
      });
      this.syncBillLocationFields();
      this.searchSelectedItems = [];
      if (added > 0) this.$message({ type: "success", message: `成功添加 ${added} 条货品` });
      if (added == 0 && duplicate > 0) this.$message({ type: "warning", message: "所选货品已在出库明细中" });
    },
    copySourceDetail(row) {
      const stockNumber = Number(row.stockRemain || 1);
      return {
        ...row,
        id: row.id || row.ID,
        billCode: this.bill.billCode,
        billType: this.bill.billType,
        companyId: row.companyID || row.companyId || this.currentCompanyId(),
        companyID: row.companyID || row.companyId || this.currentCompanyId(),
        originalID: row.id || row.ID,
        originalId: row.id || row.ID,
        sourceBillCode: row.sourceBillCode || row.billCode,
        processLineType: "source-out",
        stockNumber: stockNumber,
        stockRemain: stockNumber,
        storeName: row.storeCode,
        status: "0"
      };
    },
    buildReturnLine(sourceRow) {
      const source = sourceRow || {};
      const row = {
        ...source,
        id: "",
        billCode: this.bill.billCode,
        billType: this.bill.billType,
        companyId: this.currentCompanyId(),
        companyID: this.currentCompanyId(),
        processLineType: "return-in",
        sourceBillCode: this.sourceBillCode,
        originalID: source.originalID || source.originalId || source.id || "",
        originalId: source.originalID || source.originalId || source.id || "",
        serialCode: source.serialCode || "",
        brandSerialCode: source.brandSerialCode || source.serialCode || "",
        detailCode: source.detailCode || "",
        detailName: source.detailName || "",
        brandCode: source.brandCode || "",
        brandName: source.brandName || "",
        brandModelCode: source.brandModelCode || "",
        factoryCode: source.factoryCode || "",
        factoryName: source.factoryName || "",
        factoryModelCode: source.factoryModelCode || "",
        spuCode: source.spuCode || source.productCode || "",
        certNumber: source.certNumber || "",
        className: this.normalizeClassName(source.className),
        unitName: source.unitName || "",
        storeCode: source.storeCode || this.defaultStoreCode(),
        storeName: source.storeName || source.storeCode || this.defaultStoreCode(),
        channel: source.channel || this.defaultChannel(),
        weight: this.toNumber(source.weight),
        goldWeight: source.goldWeight || source.goldWeight === 0 ? this.toNumber(source.goldWeight) : 0,
        goldInPrice: this.toNumber(source.goldInPrice),
        goldInTaxPrice: source.goldInTaxPrice || source.goldInTaxPrice === 0 ? this.toNumber(source.goldInTaxPrice) : this.toNumber(source.goldInPrice),
        laborUnitPrice: this.toNumber(source.laborUnitPrice),
        laborUnitTaxPrice: source.laborUnitTaxPrice || source.laborUnitTaxPrice === 0 ? this.toNumber(source.laborUnitTaxPrice) : this.toNumber(source.laborUnitPrice),
        laborPiecePrice: this.toNumber(source.laborPiecePrice),
        laborPieceTaxPrice: source.laborPieceTaxPrice || source.laborPieceTaxPrice === 0 ? this.toNumber(source.laborPieceTaxPrice) : this.toNumber(source.laborPiecePrice),
        otherPiecePrice: this.toNumber(source.otherPiecePrice),
        otherPieceTaxPrice: source.otherPieceTaxPrice || source.otherPieceTaxPrice === 0 ? this.toNumber(source.otherPieceTaxPrice) : this.toNumber(source.otherPiecePrice),
        stoneBoundPrice: this.toNumber(source.stoneBoundPrice),
        stoneBoundTaxPrice: source.stoneBoundTaxPrice || source.stoneBoundTaxPrice === 0 ? this.toNumber(source.stoneBoundTaxPrice) : this.toNumber(source.stoneBoundPrice),
        noTaxPurchasePrice: this.toNumber(source.noTaxPurchasePrice),
        taxPrice: this.toNumber(source.taxPrice),
        purchasePrice: this.toNumber(source.purchasePrice),
        useBrandPrice: this.toNumber(source.useBrandPrice),
        productPrice: this.toNumber(source.productPrice),
        sellPrice: this.toNumber(source.sellPrice),
        stockNumber: Math.abs(Number(source.stockNumber || 1)) || 1,
        stockRemain: Math.abs(Number(source.stockNumber || 1)) || 1,
        stockStatus: "available",
        remark: this.template == "gold" ? "融金回货入库" : (this.template == "tolling" ? "送料加工回货入库" : "维修回货入库"),
        status: "0",
        _resolvedDetailCode: "",
        _skuResolving: false,
        _skuError: ""
      };
      this.normalizeTaxFields(row);
      this.calculatePurchasePriceByTax(row, "init");
      if (this.hasCompleteSkuFields(row)) row._resolvedDetailCode = row.detailCode;
      return row;
    },
    initializeReturnLine(sourceRow) {
      const row = sourceRow || {};
      row.className = this.normalizeClassName(row.className);
      row._resolvedDetailCode = "";
      row._skuResolving = false;
      row._skuError = "";
      this.normalizeTaxFields(row);
      this.calculatePurchasePriceByTax(row, "init");
      return row;
    },
    normalizeClassName(className) {
      const value = (className || "").trim();
      if (value === "按克计价" || value === "非一口价" || value === "按克") return "按克";
      if (!value || value === "一口价" || value === "按件计价" || value === "按件") return "按件";
      return value;
    },
    onClassNameChange(row) {
      row.className = this.normalizeClassName(row.className);
      this.calculatePurchasePriceByTax(row, "className");
    },
    skuSummary(row) {
      if (!row) return "";
      return [row.detailName, row.brandModelCode ? `品牌款号：${row.brandModelCode}` : ""].filter(item => !!item).join(" / ");
    },
    hasCompleteSkuFields(row) {
      return !!(row && row.detailCode && row.detailName && row.brandCode && row.brandName
        && row.brandModelCode && row.factoryCode && row.factoryName);
    },
    clearReturnSkuFields(row) {
      if (!row) return;
      row.detailName = "";
      row.brandCode = "";
      row.brandName = "";
      row.brandModelCode = "";
      row.factoryCode = "";
      row.factoryName = "";
      row.factoryModelCode = "";
      row.spuCode = "";
      row.unitName = "";
      row._resolvedDetailCode = "";
    },
    skuValidationMessage(sku, detailCode) {
      if (!sku) return `未找到系统款号 ${detailCode} 的款式信息`;
      if (String(sku.status || "").toLowerCase() === "disabled") return `系统款号 ${detailCode} 的款式已禁用`;
      if (!sku.detailName) return `款式 ${detailCode} 缺少名称`;
      if (!sku.brandCode || !sku.brandName) return `款式 ${detailCode} 缺少品牌信息`;
      if (!sku.factoryCode || !sku.factoryName) return `款式 ${detailCode} 缺少工厂信息`;
      if (!sku.brandModelCode) return `款式 ${detailCode} 缺少品牌款号`;
      return "";
    },
    resolveReturnSku(row, showMessage = false, force = false) {
      if (!row) return Promise.resolve(false);
      const detailCode = (row.detailCode || "").trim();
      row.detailCode = detailCode;
      if (!detailCode) {
        this.clearReturnSkuFields(row);
        row._skuError = "请输入系统款号";
        if (showMessage) this.$message({ type: "warning", message: row._skuError });
        return Promise.resolve(false);
      }
      if (!force && row._resolvedDetailCode === detailCode && this.hasCompleteSkuFields(row)) {
        row._skuError = "";
        return Promise.resolve(true);
      }

      this.clearReturnSkuFields(row);
      row.detailCode = detailCode;
      row._skuResolving = true;
      row._skuError = "";
      return fetchSkuByDetailCode(detailCode).then((res) => {
        if (row.detailCode !== detailCode) return false;
        const sku = res.code == 200 ? res.data : null;
        const message = this.skuValidationMessage(sku, detailCode);
        if (message) {
          row._skuError = message;
          if (showMessage) this.$message({ type: "warning", message });
          return false;
        }
        row.detailName = sku.detailName || "";
        row.brandCode = sku.brandCode || "";
        row.brandName = sku.brandName || "";
        row.brandModelCode = sku.brandModelCode || "";
        row.factoryCode = sku.factoryCode || "";
        row.factoryName = sku.factoryName || "";
        row.factoryModelCode = sku.factoryModelCode || "";
        row.spuCode = sku.productCode || "";
        row.unitName = sku.detailUnit || "";
        row._resolvedDetailCode = detailCode;
        row._skuError = "";
        return true;
      }).catch((err) => {
        if (row.detailCode !== detailCode) return false;
        const message = (err && err.content) || `系统款号 ${detailCode} 匹配失败`;
        row._skuError = message;
        if (showMessage) this.$message({ type: "error", message });
        return false;
      }).finally(() => {
        if (row.detailCode === detailCode) row._skuResolving = false;
      });
    },
    resolveAllReturnSkus(showMessage = false, force = false) {
      return Promise.all(this.returnDetails.map(row => this.resolveReturnSku(row, showMessage, force)))
        .then(results => results.every(item => item === true));
    },
    buildSettlementLine() {
      const source = this.sourceDetails[0] || {};
      return {
        billCode: this.bill.billCode,
        billType: this.bill.billType,
        companyId: this.currentCompanyId(),
        companyID: this.currentCompanyId(),
        processLineType: "settlement",
        sourceBillCode: this.sourceBillCode,
        originalID: source.originalID || source.originalId || source.id || "",
        detailCode: source.detailCode || "",
        detailName: source.detailName || "",
        serialCode: source.serialCode || "",
        storeCode: source.storeCode || "",
        channel: source.channel || "",
        stockNumber: 0,
        stockRemain: 0,
        remark: "融金回款结案",
        status: "0"
      };
    },
    addReturnLine() {
      this.details.push(this.buildReturnLine());
    },
    onTollingSupplierChange(value) {
      const supplier = this.suppliers.find(item => item.id == value);
      if (!supplier) return;
      this.tolling.supplierCode = supplier.supplierCode || "";
      this.tolling.supplierName = supplier.supplierName || "";
      this.tolling.contactName = supplier.contactName || "";
      this.tolling.contactPhone = supplier.contactPhone || "";
    },
    addTollingPlan() {
      this.tollingPlans.push({
        detailID: "",
        detailCode: "",
        detailName: "",
        unitName: "",
        storeCode: this.defaultStoreCode(),
        plannedQuantity: 1,
        _skuKeyword: ""
      });
    },
    removeTollingPlan(index) {
      this.tollingPlans.splice(index, 1);
    },
    skuFetchSuggestions(queryString, callback) {
      const keyword = (queryString || "").trim();
      if (!keyword) {
        callback([]);
        return;
      }
      const search = {
        page: 1,
        rows: 10,
        columns: [
          { prop: "detailCode", searchable: true },
          { prop: "detailName", searchable: true },
          { prop: "detailUnit", searchable: true },
          { prop: "serialCode", searchable: true },
          { prop: "brandCode", searchable: true, permission: 1 },
          { prop: "brandName", searchable: true, permission: 1 },
          { prop: "brandModelCode", searchable: true, permission: 1 },
          { prop: "factoryCode", searchable: true, permission: 1 },
          { prop: "factoryName", searchable: true, permission: 1 },
          { prop: "factoryModelCode", searchable: true, permission: 1 }
        ],
        filters: [
          { name: "status", value: "enabled" }
        ],
        keyword,
        queryType: 3
      };
      fetchSkuList(search).then((res) => {
        const rows = res?.data?.data || [];
        callback(rows
          .filter(item => String(item.status || "").toLowerCase() != "disabled")
          .map(item => ({
            ...item,
            value: `${item.detailCode || ""}｜${item.detailName || ""}${item.brandModelCode ? `｜${item.brandModelCode}` : ""}`
          })));
      }).catch(() => callback([]));
    },
    selectTollingPlanSku(row, sku) {
      if (!row || !sku) return;
      row.detailID = sku.id || "";
      row.detailCode = sku.detailCode || "";
      row.detailName = sku.detailName || "";
      row.unitName = sku.detailUnit || sku.unitName || "";
      row._skuKeyword = row.detailCode;
    },
    resolveTollingPlanInput(row) {
      const keyword = (row?._skuKeyword || "").trim();
      if (!keyword) {
        this.clearTollingPlanSku(row);
        return;
      }
      if (keyword == row.detailCode && row.detailName) return;
      this.resolveTollingPlan(row, keyword);
    },
    clearTollingPlanSku(row) {
      if (!row) return;
      row.detailID = "";
      row.detailCode = "";
      row.detailName = "";
      row.unitName = "";
    },
    resolveTollingPlan(row, inputCode = "") {
      const code = (inputCode || row.detailCode || "").trim();
      if (!code) return Promise.resolve(false);
      return fetchSkuByDetailCode(code).then(res => {
        const sku = res.data;
        if (!sku || String(sku.status || "").toLowerCase() == "disabled") {
          this.clearTollingPlanSku(row);
          this.$message.warning(`计划成品 ${code} 不存在或已停用，请从搜索结果中选择`);
          return false;
        }
        this.selectTollingPlanSku(row, sku);
        return true;
      }).catch(() => {
        this.clearTollingPlanSku(row);
        this.$message.warning(`计划成品 ${code} 不存在或已停用，请从搜索结果中选择`);
        return false;
      });
    },
    applyPlanToReturn(row) {
      const plan = this.tollingPlans.find(item => item.id == row._planID);
      if (!plan) return;
      row.detailCode = plan.detailCode;
      row.detailName = plan.detailName;
      row.unitName = plan.unitName;
      row.storeCode = plan.storeCode || row.storeCode;
      this.resolveReturnSku(row, true, true);
    },
    applyRepairPlanToReturn(row) {
      const item = this.repairPlans.find(value => value.plan?.id == row._planTempID);
      if (!item) return;
      const planID = row._planTempID;
      const current = { ...row };
      const merged = this.buildReturnLine(item.plan);
      // 导入或人工填写的显式值优先；只有真正的空值才使用预计明细默认值，0 也必须保留。
      Object.keys(current).forEach((key) => {
        if (current[key] !== undefined && current[key] !== null && current[key] !== "") {
          merged[key] = current[key];
        }
      });
      Object.assign(row, merged);
      row._planTempID = planID;
      row.detailCode = item.plan.detailCode;
      row.detailName = item.plan.detailName;
      row.originalID = item.plan.originalID || item.plan.originalId || row.originalID;
      row.originalId = row.originalID;
      row.sourceBillCode = item.plan.sourceBillCode || row.sourceBillCode;
      this.resolveReturnSku(row, false, true);
    },
    addRepairPlanLine(item) {
      if (!item?.plan || Number(item.availableQuantity || 0) <= 0) return;
      const row = this.buildReturnLine(item.plan);
      row._planTempID = item.plan.id;
      row.stockNumber = Number(item.availableQuantity || 0);
      row.stockRemain = row.stockNumber;
      this.details.push(row);
    },
    addAllRepairPlanLines() {
      this.repairPlans.filter(item => Number(item.availableQuantity || 0) > 0).forEach(item => this.addRepairPlanLine(item));
    },
    batchQuantity(row) {
      return (row.details || []).reduce((sum, item) => sum + Number(item.detail?.stockNumber || 0), 0);
    },
    editTollingBatch(row) {
      this.tollingBatch = { ...(row.batch || {}) };
      this.details = (row.details || []).map(item => {
        const detail = this.initializeReturnLine({ ...(item.detail || {}) });
        detail._planID = item.planID || "";
        return detail;
      });
      if (this.returnDetails.length > 0) this.resolveAllReturnSkus(false, true);
    },
    showTollingBatchDetails(row) {
      this.selectedTollingBatch = row || null;
      this.showTollingDetailDialog = true;
    },
    editRepairBatch(row) {
      this.repairBatch = { ...(row.batch || {}) };
      this.details = this.details.filter(item => item.processLineType != "return-in");
      (row.details || []).forEach(item => {
        const detail = this.initializeReturnLine({ ...(item.detail || {}) });
        detail._planTempID = item.planTempID || "";
        this.details.push(detail);
      });
      if (this.returnDetails.length > 0) this.resolveAllReturnSkus(false, true);
    },
    auditRepairBatch(row) {
      this.$confirm(`确认由财务审核批次 ${row.batch.batchCode} 并生成独立维修入库待审核单？`, "财务审核入库", { type: "warning" })
        .then(() => auditPendingRepairBatch(this.id, row.batch.id).then(res => this.afterAction(res, false)))
        .catch(() => {});
    },
    cancelRepairBatch(row) {
      this.$prompt(`取消批次 ${row.batch.batchCode} 后将释放占用的预计数量，请填写原因。`, "取消维修回货批次", {
        confirmButtonText: "确认取消", cancelButtonText: "返回", inputType: "textarea", inputPattern: /\S+/, inputErrorMessage: "取消原因不能为空", type: "warning"
      }).then(({ value }) => cancelPendingRepairBatch(this.id, row.batch.id, { reason: (value || "").trim() })
        .then(res => this.afterAction(res, false))).catch(() => {});
    },
    repairBatchStatusText(status) {
      const map = { 0: "待财务审核", 11: "待财务审核（旧单）", 21: "待财务审核（旧单）", 1: "已完成", "-1": "已取消" };
      return map[status] || "其他";
    },
    removeTollingBatch(row) {
      this.$confirm(`确认删除回货批次 ${row.batch?.batchCode || ""}？`, "删除批次", { type: "warning" }).then(() => {
        deletePendingTollingBatch(this.id, row.batch.id).then(res => this.afterAction(res, false));
      }).catch(() => {});
    },
    openQuickReturnDialog() {
      if (this.sourceDetails.length == 0) {
        this.$message({ type: "warning", message: "未找到原出库货品明细" });
        return;
      }
      this.quickReturnSelectedItems = [];
      this.showQuickReturnDialog = true;
    },
    handleQuickReturnSelectionChange(selection) {
      this.quickReturnSelectedItems = selection || [];
    },
    batchAddReturnFromSource() {
      let added = 0;
      this.quickReturnSelectedItems.forEach((item) => {
        this.details.push(this.buildReturnLine(item));
        added += 1;
      });
      this.quickReturnSelectedItems = [];
      this.showQuickReturnDialog = false;
      if (added > 0) this.$message({ type: "success", message: `成功生成 ${added} 条回货入库明细` });
    },
    downloadImportTemplate() {
      fetchPendingReturnImportTemplate().then((res) => {
        if (res.code == 200 && res.data) {
          window.location.href = process.env.VUE_APP_BASEURL + res.data;
        } else {
          this.$message.error(res.content || "模板生成失败");
        }
      }).catch((err) => {
        this.$message.error((err && err.content) || "模板生成失败");
      });
    },
    openImportDialog() {
      this.importFileList = [];
      this.showImportDialog = true;
    },
    handleImportExceed() {
      this.$message({ message: "每次只能上传一个文件", type: "warning" });
    },
    submitImportUpload(file) {
      this.importLoading = true;
      const dataList = new FormData();
      dataList.append(file.file.name, file.file);
      dataList.append("fileType", "excel");
      dataList.append("dataType", "ImportPendingReturn");
      this.$refs.importUpload.clearFiles();
      this.importFileList = [];

      uploader(dataList).then((res) => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          return parsePendingReturnImport(
            res.data[0].id,
            this.id,
            this.isRepairBatchMode ? (this.repairBatch.id || "") : ""
          );
        }
        return Promise.reject(res);
      }).then((res) => {
        this.appendImportedRows(res.data || []);
      }).catch((err) => {
        this.$alert((err && err.content) || "导入失败，请重试", "提示");
      }).finally(() => {
        this.importLoading = false;
      });
    },
    // 将后端解析的导入数据追加为回货入库明细；复用 buildReturnLine 骨架，货品与价格字段以表格值为准
    appendImportedRows(rows) {
      if (!rows || rows.length === 0) {
        this.$message({ type: "warning", message: "未解析到可导入的数据" });
        return;
      }
      rows.forEach((item) => {
        const row = this.buildReturnLine(item);
        row._planTempID = item.planTempID || "";
        delete row.planTempID;
        if (item.remark) row.remark = item.remark;
        this.details.push(row);
      });
      this.showImportDialog = false;
      this.$message({ type: "success", message: `成功导入 ${rows.length} 条回货入库明细，请核对后保存` });
    },
    addSettlementLine() {
      if (this.settlementAddConfirmed) {
        this.details.push(this.buildSettlementLine());
        return;
      }
      this.$confirm(
        "融金回款记录仅用于回款结案，不会生成入库流水。确认新增回款记录吗？",
        "新增回款记录提示",
        { confirmButtonText: "确认新增", cancelButtonText: "取消", type: "warning" }
      ).then(() => {
        this.settlementAddConfirmed = true;
        this.details.push(this.buildSettlementLine());
      }).catch(() => {});
    },
    removeDetailLine(row) {
      this.details = this.details.filter(item => item !== row);
    },
    removeSource(row) {
      this.details = this.details.filter(item => item !== row);
      this.syncBillLocationFields();
    },
    clearSourceDetails() {
      this.details = this.details.filter(item => item.processLineType != "source-out");
      this.syncBillLocationFields();
    },
    validateCreate() {
      if (!this.currentCompanyId()) return "请选择所属公司";
      if (this.sourceDetails.length == 0) return "请先添加出库货品";
      const invalid = this.sourceDetails.find(item => !item.stockNumber || Number(item.stockNumber) <= 0);
      if (invalid) return "出库数量必须大于0";
      if (this.template == "tolling") {
        if (!this.tolling.supplierID) return "请选择加工供应商";
        if (!this.tolling.expectedReturnDate) return "请选择预计回货日期";
        if (this.tollingPlans.length == 0) return "请添加计划回货成品";
        const invalidPlan = this.tollingPlans.find(item => !item.detailCode || !item.detailName || !item.storeCode || Number(item.plannedQuantity || 0) <= 0);
        if (invalidPlan) return "请完整填写计划成品、默认入库仓库和计划数量";
      }
      return "";
    },
    validateCompletion() {
      if (!this.isReturnBill) return "";
      if (this.requiresReturn && this.returnDetails.length == 0) return "请维护回货入库明细";
      if (!this.requiresReturn && this.settlementDetails.length == 0) return "请维护回款记录";
      if (this.requiresReturn) {
        for (const row of this.returnDetails) {
          if (this.isRepairBatchMode && !row._planTempID) return "每条实际回货明细都必须选择预计维修明细";
          const msg = this.validateReturnInLine(row);
          if (msg) return msg;
        }
      }
      return "";
    },
    toNumber(val) {
      const num = Number(val);
      return Number.isFinite(num) ? num : 0;
    },
    roundMoney(val) {
      const num = this.toNumber(val);
      const sign = num < 0 ? -1 : 1;
      const absolute = Math.abs(num);
      const epsilon = Number.EPSILON * Math.max(1, absolute);
      return sign * Math.round((absolute + epsilon) * 100) / 100;
    },
    normalizeNumberField(row, field) {
      if (!row || !field) return;
      if (row[field] === "" || row[field] == null) return;
      row[field] = this.toNumber(row[field]);
    },
    isByWeightPriced(row) {
      const className = (row && row.className) || "";
      return className === "按克计价" || className === "按克" || className === "非一口价";
    },
    normalizeTaxFields(row) {
      if (!row) return row;
      if (row.goldInTaxPrice == null || row.goldInTaxPrice === "") row.goldInTaxPrice = this.toNumber(row.goldInPrice);
      if (row.laborUnitTaxPrice == null || row.laborUnitTaxPrice === "") row.laborUnitTaxPrice = this.toNumber(row.laborUnitPrice);
      if (row.laborPieceTaxPrice == null || row.laborPieceTaxPrice === "") row.laborPieceTaxPrice = this.toNumber(row.laborPiecePrice);
      if (row.otherPieceTaxPrice == null || row.otherPieceTaxPrice === "") row.otherPieceTaxPrice = this.toNumber(row.otherPiecePrice);
      if (row.stoneBoundTaxPrice == null || row.stoneBoundTaxPrice === "") row.stoneBoundTaxPrice = this.toNumber(row.stoneBoundPrice);
      if (row.unitPrice == null || row.unitPrice === "") row.unitPrice = 0;
      if (row.useBrandPrice == null || row.useBrandPrice === "") row.useBrandPrice = 0;
      return row;
    },
    calculatePurchasePriceByTax(row, source = "") {
      if (!row) return;
      this.normalizeTaxFields(row);

      if (this.isByWeightPriced(row)) {
        const goldWeight = this.toNumber(row.goldWeight);
        const noTaxPurchasePrice =
          goldWeight * this.toNumber(row.goldInPrice) +
          goldWeight * this.toNumber(row.laborUnitPrice) +
          this.toNumber(row.laborPiecePrice) +
          this.toNumber(row.stoneBoundPrice) +
          this.toNumber(row.otherPiecePrice);
        const purchasePrice =
          goldWeight * this.toNumber(row.goldInTaxPrice) +
          goldWeight * this.toNumber(row.laborUnitTaxPrice) +
          this.toNumber(row.laborPieceTaxPrice) +
          this.toNumber(row.stoneBoundTaxPrice) +
          this.toNumber(row.otherPieceTaxPrice);
        row.noTaxPurchasePrice = noTaxPurchasePrice;
        row.purchasePrice = purchasePrice;
      }

      row.noTaxPurchasePrice = this.roundMoney(row.noTaxPurchasePrice);
      row.purchasePrice = this.roundMoney(row.purchasePrice);
      row.useBrandPrice = this.roundMoney(row.useBrandPrice);

      const stockNumber = this.toNumber(row.stockNumber);
      if (!this.isByWeightPriced(row) && source === "unitPrice") {
        row.noTaxPurchasePrice = this.roundMoney(this.toNumber(row.unitPrice) * stockNumber);
      } else if (!this.isByWeightPriced(row) && source === "stockNumber" && this.toNumber(row.unitPrice) > 0) {
        row.noTaxPurchasePrice = this.roundMoney(this.toNumber(row.unitPrice) * stockNumber);
      } else if (source === "noTaxPurchasePrice" && stockNumber > 0) {
        row.unitPrice = this.roundMoney(this.toNumber(row.noTaxPurchasePrice) / stockNumber);
      } else if ((source === "purchasePrice" || source === "useBrandPrice") && stockNumber > 0 && this.toNumber(row.noTaxPurchasePrice) > 0) {
        row.unitPrice = this.roundMoney(this.toNumber(row.noTaxPurchasePrice) / stockNumber);
      }

      const noTaxPurchasePrice = this.toNumber(row.noTaxPurchasePrice);
      const taxPrice = this.toNumber(row.taxPrice);
      const purchasePrice = this.toNumber(row.purchasePrice);
      if (purchasePrice <= 0 && (noTaxPurchasePrice > 0 || taxPrice > 0)) {
        row.purchasePrice = this.roundMoney(noTaxPurchasePrice + taxPrice);
      }

      row.purchasePrice = this.roundMoney(row.purchasePrice);
      row.taxPrice = this.roundMoney(this.toNumber(row.purchasePrice) - this.toNumber(row.noTaxPurchasePrice));
      row.productPrice = this.roundMoney(this.toNumber(row.purchasePrice) + this.toNumber(row.useBrandPrice));
    },
    itemChange(row, source = "") {
      this.normalizeNumberField(row, source);
      this.calculatePurchasePriceByTax(row, source);
    },
    validateTaxFields(row) {
      if (this.toNumber(row.purchasePrice) < this.toNumber(row.noTaxPurchasePrice)) {
        return "含税采购价必须大于等于不含税采购价";
      }
      const checks = [
        { tax: "goldInTaxPrice", base: "goldInPrice", label: "含税金单价" },
        { tax: "laborUnitTaxPrice", base: "laborUnitPrice", label: "含税克工费" },
        { tax: "laborPieceTaxPrice", base: "laborPiecePrice", label: "含税件工费" },
        { tax: "otherPieceTaxPrice", base: "otherPiecePrice", label: "含税其他费用" },
        { tax: "stoneBoundTaxPrice", base: "stoneBoundPrice", label: "含税镶嵌物费用" },
      ];
      for (const item of checks) {
        if (row[item.tax] != null && row[item.tax] !== "" && this.toNumber(row[item.tax]) < this.toNumber(row[item.base])) {
          return `${item.label}必须大于等于对应不含税字段`;
        }
      }
      return "";
    },
    validateReturnInLine(row) {
      this.normalizeTaxFields(row);
      this.calculatePurchasePriceByTax(row, "init");
      const prefix = row.serialCode || row.brandSerialCode || row.detailCode || "回货入库明细";
      if (!row.storeCode || !row.channel) return `${prefix}: 请选择入库库房及渠道`;
      if (!row.detailCode) return `${prefix}: 请填写系统款号`;
      if (row._skuError || !this.hasCompleteSkuFields(row)) return `${prefix}: ${row._skuError || "系统款号尚未匹配款式主数据"}`;
      if (row.className !== "按克" && row.className !== "按件") return `${prefix}: 计价类型只能为按克或按件`;
      if (!row.serialCode) return `${prefix}: 请填写回货批次号`;
      if (!row.brandSerialCode) return `${prefix}: 请填写品牌批次号`;
      if (!row.stockNumber || this.toNumber(row.stockNumber) <= 0) return `${prefix}: 请填写正确的入库数量`;
      if (row.weight == null || row.weight === "" || this.toNumber(row.weight) < 0) return `${prefix}: 请填写正确的克重`;
      if (row.goldWeight == null || row.goldWeight === "" || this.toNumber(row.goldWeight) < 0) return `${prefix}: 请填写正确的金重（无金材质请填写0）`;
      if (row.className === "按克" && this.toNumber(row.goldWeight) <= 0) return `${prefix}: 按克计价必须填写大于0的金重`;
      if (this.toNumber(row.goldWeight) > this.toNumber(row.weight)) return `${prefix}: 金重不可以大于克重`;
      if (this.toNumber(row.goldWeight) > 0 && this.toNumber(row.goldInPrice) <= 0) return `${prefix}: 请填写入库金单价`;
      if (this.toNumber(row.goldWeight) > 0 && this.toNumber(row.laborPiecePrice) <= 0 && this.toNumber(row.laborUnitPrice) <= 0) return `${prefix}: 请填写入库克工费或件工费`;
      const taxMessage = this.validateTaxFields(row);
      if (taxMessage) return `${prefix}: ${taxMessage}`;
      if (this.toNumber(row.noTaxPurchasePrice) <= 0) return `${prefix}: 请填写不含税采购价`;
      if (this.toNumber(row.purchasePrice) <= 0) return `${prefix}: 请填写含税采购价`;
      if (this.toNumber(row.sellPrice) <= 0) return `${prefix}: 请填写计划售价`;
      return "";
    },
    recalcBill() {
      this.bill.billType = "待回货流程";
      this.bill.billSource = this.template + ":" + this.completionMode;
      this.bill.companyId = this.currentCompanyId();
      this.bill.companyID = this.currentCompanyId();
      const rows = this.isReturnBill ? this.completionDetails : this.sourceDetails;
      rows.forEach(row => {
        if (row.processLineType == "return-in") this.calculatePurchasePriceByTax(row, "init");
      });
      this.bill.productNumber = rows.reduce((sum, item) => sum + Number(item.stockNumber || 0), 0);
      this.bill.costTotal = rows.reduce((sum, item) => sum + Number(item.productPrice || 0) * Math.abs(Number(item.stockNumber || 1)), 0);
      this.bill.goldWeightTotal = rows.reduce((sum, item) => sum + Number(item.goldWeight || 0) * Math.abs(Number(item.stockNumber || 1)), 0);
      this.syncBillLocationFields();
    },
    syncBillLocationFields() {
      const rows = this.isReturnBill ? this.completionDetails : this.sourceDetails;
      this.bill.storeCode = this.distinctText(rows.map(item => item.storeCode));
      this.bill.channelCode = this.distinctText(rows.map(item => item.channel));
      if (!this.isReturnBill) this.bill.netCode = this.distinctText(rows.map(item => item.sourceBillCode || item.billCode));
    },
    currentCompanyId() {
      return this.bill.companyId || this.bill.companyID || "";
    },
    distinctText(values) {
      return [...new Set((values || []).filter(item => item && item.length > 0))].join(";");
    },
    defaultStoreCode() {
      return this.dict.stores[0]?.value || this.dict.stores[0]?.name || "成品库";
    },
    defaultChannel() {
      return this.dict.channels[0]?.value || this.dict.channels[0]?.name || "";
    },
    payload() {
      this.recalcBill();
      return { bill: this.bill, details: this.sourceDetails, template: this.template, completionMode: this.completionMode,
        tolling: this.template == "tolling" ? this.tolling : null,
        plans: this.template == "tolling" ? this.tollingPlans.map(({ _skuKeyword, ...plan }) => plan) : [] };
    },
    completionPayload() {
      return this.completionDetails.map(row => {
        const item = { ...row };
        delete item._resolvedDetailCode;
        delete item._skuResolving;
        delete item._skuError;
        return item;
      });
    },
    prepareCompletionForSubmit() {
      const resolvePromise = this.requiresReturn ? this.resolveAllReturnSkus(false, false) : Promise.resolve(true);
      return resolvePromise.then((resolved) => {
        if (!resolved) {
          const invalid = this.returnDetails.find(row => !!row._skuError || !this.hasCompleteSkuFields(row));
          this.$message({ type: "warning", message: invalid?._skuError || "请先完成系统款号匹配" });
          return false;
        }
        const msg = this.validateCompletion();
        if (msg) {
          this.$message({ type: "warning", message: msg });
          return false;
        }
        this.recalcBill();
        return true;
      });
    },
    submitCreate() {
      const msg = this.validateCreate();
      if (msg) {
        this.$message({ type: "warning", message: msg });
        return;
      }
      submitPendingReturn(this.payload()).then((res) => this.afterAction(res, true));
    },
    saveCompletion(options = {}) {
      return this.prepareCompletionForSubmit().then((ready) => {
        if (!ready) return false;
        if (this.isRepairBatchMode) {
          if (!this.repairBatch.returnDate) {
            this.$message.warning("请选择回货日期");
            return false;
          }
          const details = this.returnDetails.map(row => ({ planTempID: row._planTempID || "", detail: this.cleanReturnLine(row) }));
          const action = savePendingRepairBatch(this.id, { batch: this.repairBatch, details });
          return action.then(res => {
            this.afterAction(res, false);
            return res.code == 200;
          });
        }
        if (this.template == "tolling") {
          if (!this.tollingBatch.returnDate || !this.tollingBatch.receiverName) {
            this.$message.warning("请填写回货日期和收货人");
            return false;
          }
          const details = this.returnDetails.map(row => ({ planID: row._planID || "", detail: this.cleanReturnLine(row) }));
          return savePendingTollingBatch(this.id, { batch: this.tollingBatch, details }).then((res) => {
            this.afterAction(res, false);
            return res.code == 200;
          });
        }
        return savePendingReturnCompletion(this.id, this.completionPayload()).then((res) => {
          if (!options.silent || res.code != 200) {
            this.afterAction(res, false);
          } else if (options.reload !== false) {
            this.loadDetail();
          }
          return res.code == 200;
        });
      });
    },
    cleanReturnLine(row) {
      const item = { ...row };
      delete item._planID;
      delete item._planTempID;
      delete item._resolvedDetailCode;
      delete item._skuResolving;
      delete item._skuError;
      return item;
    },
    submitTollingForReview() {
      if (this.returnDetails.length > 0) {
        this.$message.warning("当前批次尚未保存，请先保存回货批次");
        return;
      }
      const exact = this.tollingProgress.isExact === true;
      if (exact) {
        submitPendingTollingReturn(this.id, { varianceClosed: false }).then(res => this.afterAction(res, false));
        return;
      }
      this.varianceForm = {
        varianceReason: this.tolling.varianceReason || "",
        varianceResponsibility: this.tolling.varianceResponsibility || "",
        varianceRemark: this.tolling.varianceRemark || ""
      };
      this.showVarianceDialog = true;
    },
    confirmTollingVariance() {
      const payload = {
        varianceClosed: true,
        varianceReason: (this.varianceForm.varianceReason || "").trim(),
        varianceResponsibility: (this.varianceForm.varianceResponsibility || "").trim(),
        varianceRemark: (this.varianceForm.varianceRemark || "").trim()
      };
      if (!payload.varianceReason || !payload.varianceResponsibility || !payload.varianceRemark) {
        this.$message.warning("差异原因、责任方和差异说明均不能为空");
        return;
      }
      submitPendingTollingReturn(this.id, payload).then(res => {
        if (res.code == 200) this.showVarianceDialog = false;
        this.afterAction(res, false);
      });
    },
    approveStage() {
      if (this.isReturnBill && this.template == "tolling") {
        confirmPendingReturn(this.id).then((res) => this.afterAction(res));
        return;
      }
      const before = this.isReturnBill ? this.saveCompletion() : Promise.resolve(true);
      before.then((ok) => {
        if (ok === false) return;
        const action = this.isReturnBill ? confirmPendingReturn : approvePendingReturn;
        action(this.id).then((res) => this.afterAction(res));
      });
    },
    cancelApplication() {
      this.$prompt("取消后申请不可恢复，请填写取消原因。", "取消申请", {
        confirmButtonText: "确认取消",
        cancelButtonText: "返回",
        inputType: "textarea",
        inputPattern: /\S+/,
        inputErrorMessage: "取消原因不能为空",
        type: "warning"
      }).then(({ value }) => {
        cancelPendingReturn(this.id, { reason: (value || "").trim() })
          .then((res) => this.afterAction(res, true));
      }).catch(() => {});
    },
    canCancelSourceDetail(row) {
      return this.canCancelApplication
        && String(row?.status || "0") == "0"
        && this.activeSourceDetailCount > 1;
    },
    cancelSourceDetail(row) {
      const detailId = row?.id || row?.ID || "";
      if (!detailId || !this.canCancelSourceDetail(row)) return;

      const label = row.serialCode || row.detailCode || "该货品";
      this.$prompt(`取消后该明细不会实际出库，请填写取消原因。货品：${label}`, "取消出库明细", {
        confirmButtonText: "确认取消",
        cancelButtonText: "返回",
        inputType: "textarea",
        inputPattern: /\S+/,
        inputErrorMessage: "取消原因不能为空",
        type: "warning"
      }).then(({ value }) => {
        cancelPendingReturnDetail(this.id, detailId, { reason: (value || "").trim() })
          .then((res) => this.afterAction(res, false));
      }).catch(() => {});
    },
    reviewStage() {
      if (!this.isReturnBill) {
        reviewPendingReturn(this.id, this.sourceDetails).then((res) => this.afterAction(res));
        return;
      }
      if (this.template == "tolling") {
        reviewPendingReturn(this.id, []).then((res) => this.afterAction(res));
        return;
      }
      this.prepareCompletionForSubmit().then((ready) => {
        if (ready) reviewPendingReturn(this.id, this.completionPayload()).then((res) => this.afterAction(res));
      });
    },
    auditStage() {
      if (this.template == "tolling") {
        auditPendingReturn(this.id).then((res) => this.afterAction(res, true));
        return;
      }
      const before = this.isReturnBill ? this.saveCompletion({ silent: true, reload: false }) : Promise.resolve(true);
      before.then((ok) => {
        if (ok !== false) auditPendingReturn(this.id).then((res) => this.afterAction(res, true));
      });
    },
    afterAction(res, back) {
      this.$notify({
        title: res.code == 200 ? "操作成功" : "操作失败",
        message: res.content,
        type: res.type,
        duration: 10000
      });
      if (res.code == 200) {
        const inBillCode = res.data?.inBillCode || res.data?.InBillCode || "";
        if (inBillCode) {
          this.$router.push({ path: "/stock/bills/indetail", query: { billCode: inBillCode } });
          return;
        }
        if (back) {
          this.$router.push("/stock/bills/pendingReturn");
        } else {
          this.loadDetail();
        }
      }
    },
    openStockDetail() {
      if (this.isReturnBill && this.requiresReturn) {
        const billCode = this.returnInBillCode || `${this.bill.billCode}-IN`;
        if (!billCode) {
          this.$message({ type: "warning", message: "未找到回货入库单号" });
          return;
        }
        if (this.returnInBounds.length > 0) {
          this.$router.push({ path: "/stock/bills/detail", query: { billCode } });
        } else {
          this.$router.push({ path: "/stock/bills/indetail", query: { billCode } });
        }
        return;
      }
      const billCode = this.bill.billCode;
      this.$router.push({ path: "/stock/bills/detail", query: { billCode } });
    },
    openRepairInbound(batch) {
      const billCode = batch?.inboundBillCode;
      if (!billCode) {
        this.$message({ type: "warning", message: "该批次尚未生成入库单" });
        return;
      }
      const hasFormalFlow = this.returnInBounds.some((item) => item.billCode == billCode);
      this.$router.push({ path: hasFormalFlow ? "/stock/bills/detail" : "/stock/bills/indetail", query: { billCode } });
    },
    openSourceOutBill() {
      const billCode = this.sourceBill?.billCode || this.sourceBillCode;
      if (!billCode) {
        this.$message({ type: "warning", message: "未找到出库单号" });
        return;
      }
      this.$router.push({ path: "/stock/bills/detail", query: { billCode } });
    },
    openReturnBill() {
      this.$router.push({ path: "/stock/bills/pendingReturnDetail", query: { id: this.bill.netCode || `${this.bill.billCode}-R`, template: this.template } });
    },
    sourceTemplate(value) {
      return (value || "").split(":")[0] || "repair";
    },
    sourceMode(value) {
      return (value || "").split(":")[1] || (this.sourceTemplate(value) == "gold" ? "cash" : "return");
    },
    statusText(status) {
      const map = { 0: this.isReturnBill ? "待回货确认" : "待负责人审核", 2: this.isRepairBatchMode ? "维修分批回货中" : "待回货录入", 11: this.template == "gold" ? "待财务复核" : (this.isReturnBill ? "待财务完成" : "待库管审核"), 21: this.template == "gold" || !this.isReturnBill ? "待库管审核" : "待财务完成（旧单）", 1: "已完成", "-1": "已取消" };
      return map[status] || "草稿";
    },
    statusType(status) {
      const map = { 0: "", 2: "info", 11: "warning", 21: "warning", 1: "success", "-1": "danger" };
      return map[status] || "info";
    },
    tollingProcessStatusText() {
      const status = Number(this.bill.status);
      if (status == 2) return "已保存，待提交审核";
      if (status == 0) return "待回货确认";
      if (status == 11 || status == 21) return "待财务完成";
      if (status == 1) {
        if (this.inboundState == "已正式入库") return "已正式入库";
        if (this.inboundState == "已转入库待审核") return "已转入库待审核";
        return "已完成";
      }
      if (status == -1) return "已取消";
      return "草稿";
    },
    tollingProcessStatusType() {
      const status = Number(this.bill.status);
      if (status == -1) return "danger";
      if (status == 1 && this.inboundState == "已正式入库") return "success";
      if (status == 1 || status == 11 || status == 21) return "warning";
      if (status == 2) return "info";
      return "";
    },
    sourceDetailStatusText(row) {
      const status = String(row?.status || "0");
      if (status == "-1") return "已取消";
      if (status == "1") return "已出库";
      return "待出库";
    },
    sourceDetailStatusType(row) {
      const status = String(row?.status || "0");
      if (status == "-1") return "danger";
      if (status == "1") return "success";
      return "warning";
    },
    returnInFlowStatusText(row) {
      if (row.flowSource == "bound") return "实际已入库";
      const map = { 0: "待审核入库", "0": "待审核入库", 1: "已确认", "1": "已确认", "-1": "已取消" };
      return map[row.status] || "待审核入库";
    },
    returnInFlowStatusType(row) {
      if (row.flowSource == "bound") return "success";
      const map = { 0: "warning", "0": "warning", 1: "success", "1": "success", "-1": "danger" };
      return map[row.status] || "info";
    },
    returnInFlowKey(row) {
      if (!row) return "";
      return [
        row.serialCode || row.brandSerialCode || "",
        row.detailCode || "",
        row.storeCode || row.storeName || "",
        row.channel || ""
      ].join("|");
    }
  }
};
</script>

<style scoped>
.pending-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.pending-detail-header .el-breadcrumb {
  min-width: 0;
}

.pending-detail-header .el-button {
  flex: 0 0 auto;
  margin-left: auto;
}

.mode-alert {
  margin-bottom: 12px;
}

.settlement-no-stock-tip {
  color: var(--el-color-warning-dark-2);
  font-weight: 600;
}

.table-toolbar {
  margin: 8px 0 12px;
}

.return-table {
  margin: 18px 0 24px;
}

.sku-hint {
  margin-top: 3px;
  overflow: hidden;
  color: var(--el-text-color-secondary);
  font-size: 12px;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sku-hint-success {
  color: var(--el-color-success-dark-2);
}

.sku-hint-error {
  color: var(--el-color-danger);
  white-space: normal;
}

.dialog-actions {
  text-align: center;
}

.actions {
  margin-top: 18px;
  text-align: right;
}
</style>
